// extracted by mini-css-extract-plugin
export default {"List":"styles_List__0YsNZ","testsList":"styles_testsList__RjtYI","testsList__item":"styles_testsList__item__Apq+P"};